import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


// Subscription
export function getViewControlManageSubscriptions(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-subscriptions`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathControlSubscriptions(subscriptionId=null) {
  if (subscriptionId) {
      return `control/subscriptions/${subscriptionId}`;
  } else {
      return `control/subscriptions`;
  }
}

export function createControlSubscriptions(successCallback, errorCallback, data) {
  postAuth({
    "path": pathControlSubscriptions(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchControlSubscriptions(successCallback, errorCallback, data, subscriptionId) {
  patchAuth({
    "path": pathControlSubscriptions(subscriptionId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteControlSubscriptions(successCallback, errorCallback, subscriptionId) {
  deleteAuth({
    "path": pathControlSubscriptions(subscriptionId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

// Subscription Offer
function pathControlSubscriptionOffers(offerId=null) {
  if (offerId) {
      return `control/subscription-offers/${offerId}`;
  } else {
      return `control/subscription-offers`;
  }
}

export function createControlSubscriptionOffers(successCallback, errorCallback, data) {
  postAuth({
    "path": pathControlSubscriptionOffers(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchControlSubscriptionOffers(successCallback, errorCallback, data, offerId) {
  patchAuth({
    "path": pathControlSubscriptionOffers(offerId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteControlSubscriptionOffers(successCallback, errorCallback, offerId) {
  deleteAuth({
    "path": pathControlSubscriptionOffers(offerId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}
